import { Link } from 'react-router-dom';
import { useState } from 'react';
import { Modal, Radio, Space } from 'antd';
import DropDown from './Dropdown';
import styles from './AppFooter.module.less';
import facebookIcon from 'assets/img/facebook-now-icon.svg';
import instagramIcon from 'assets/img/instagram-now-icon.svg';
import twitterIcon from 'assets/img/twitter-now-icon.svg';
import youtubeIcon from 'assets/img/youtube-now-icon.svg';
import arrowRightGray from 'assets/img/arrow-icon-now-gray.svg';
import MailchimpSubscribe from 'react-mailchimp-subscribe';
import OmniOneSub from './OmniOneSub';
import OmniArenaSub from './OmniArenaSub';
import OmniEsportsSub from './OmniEsportsSub';

export default function AppFooter() {
	const [showSubModalVisible, setShowSubModalVisible] = useState(false);
	const [showO1SubModalVisible, setShowO1SubModalVisible] = useState(false);
	const [showOASubModalVisible, setShowOASubModalVisible] = useState(false);
	const [showOESubModalVisible, setShowOESubModalVisible] = useState(false);

	// Show Newsletter Sign-up Selection
	const showSubModal = () => {
		setShowSubModalVisible(true);
	};

	const hideSubModal = () => {
		setShowSubModalVisible(false);
	};

	// Show Omni One Mailchimp Sign Up
	const showO1SubModal = () => {
		setShowO1SubModalVisible(true);
		setShowSubModalVisible(false);
	};

	const hideO1SubModal = () => {
		setShowO1SubModalVisible(false);
	};

	// Show Omni Arena Mailchimp Sign Up
	const showOASubModal = () => {
		setShowOASubModalVisible(true);
		setShowSubModalVisible(false);
	};

	const hideOASubModal = () => {
		setShowOASubModalVisible(false);
	};

	// Show Omni Esports Mailchimp Sign Up
	const showOESubModal = () => {
		setShowOESubModalVisible(true);
		setShowSubModalVisible(false);
	};

	const hideOESubModal = () => {
		setShowOESubModalVisible(false);
	};

	const mc_O1_url =
		'https://virtuix.us9.list-manage.com/subscribe/post?u=4e183d4472ed890a7a7ea651f&amp;id=1403d7227e';
	const mc_OA_url =
		'https://virtuix.us9.list-manage.com/subscribe/post?u=4e183d4472ed890a7a7ea651f&amp;id=45d668c91f';
	const mc_OE_url =
		'https://virtuix.us9.list-manage.com/subscribe/post?u=4e183d4472ed890a7a7ea651f&amp;id=dcf1154e99';

	return (
		<div className={styles.footerBackground}>
			<div className={styles.footerContainer}>
				<div className={styles.footerRow}>
					<div className={styles.footerColumn25}>
						<div className={styles.footerSubdomainCol}>
							<div className={styles.footerSubdomainLinks}>
								<a
									href="https://omni.virtuix.com"
									className={styles.footerLinkWhite}
								>
									Omni One
								</a>
							</div>
							<div className={styles.footerSubdomainLinks}>
								{' '}
								<a
									href="https://virtuix.com/omni-arena"
									className={styles.footerLinkWhite}
								>
									Omni Arena
								</a>
							</div>
							<div className={styles.footerSubdomainLinks}>
								{' '}
								<a
									href="https://virtuix.com/developers"
									className={styles.footerLinkWhite}
								>
									Developers
								</a>
							</div>
							<div className={styles.footerDisplay1280}>
								<div className={styles.footerSubdomainLinks}>
									<a
										href="https://virtuix.com"
										className={styles.footerLinkWhite}
									>
										Virtuix
									</a>
								</div>
							</div>
							<DropDown></DropDown>
							<div className={styles.footerCopyright}>
								Copyright © Virtuix ™ 2023. All rights reserved.
							</div>
						</div>
					</div>
					<div className={styles.footerColumn25}>
						<div className={styles.footerDisplay1280}>
							<div className={styles.footerPageLinksCol}>
								<div className={styles.footerPageLinks}>
									<a
										href="https://virtuix.com/who-we-are"
										className={styles.footerLinkGray}
									>
										Who We Are
									</a>
								</div>
								<div className={styles.footerPageLinks}>
									<a
										href="https://virtuix.com/careers"
										className={styles.footerLinkGray}
									>
										Careers
									</a>
								</div>
								<div className={styles.footerPageLinks}>
									<a
										href="https://virtuix.com/legal"
										className={styles.footerLinkGray}
									>
										Legal
									</a>
								</div>
								<div className={styles.footerPageLinks}>
									<a
										href="https://virtuix.com/investors"
										className={styles.footerLinkGray}
									>
										Investors
									</a>
								</div>
								<div className={styles.footerPageLinks}>
									<a
										href="https://virtuix.com/press"
										className={styles.footerLinkGray}
									>
										Press
									</a>
								</div>
							</div>
						</div>
					</div>
					<div className={styles.footerColumn50}>
						<div className={styles.footerSignUpHeader}>
							Get our latest news and updates
						</div>
						<div className={styles.footerSubscribe} onClick={showSubModal}>
							Sign Up{' '}
							<img
								className={styles.footerSubscribeImg}
								src={arrowRightGray}
								alt=""
							/>
						</div>
						<hr className={styles.footerSubscribeHrLine}></hr>

						<Modal
							title="Sign Up"
							visible={showSubModalVisible}
							footer={null}
							onCancel={() => {
								hideSubModal();
							}}
						>
							<p>What news would you like to receive?</p>
							<Radio.Group>
								<Space direction="vertical">
									<Radio
										defaultChecked={false}
										onClick={showO1SubModal}
										value={1}
									>
										Omni One updates
									</Radio>
									<Radio onClick={showOASubModal} value={2}>
										Omni Arena updates (for operators)
									</Radio>
									<Radio onClick={showOESubModal} value={3}>
										Omni Arena esports contests (for players)
									</Radio>
								</Space>
							</Radio.Group>
						</Modal>
						<Modal
							title="Sign Up for Omni One News"
							visible={showO1SubModalVisible}
							footer={null}
							onCancel={() => {
								hideO1SubModal();
							}}
						>
							<p>Enter your email address below.</p>
							<MailchimpSubscribe
								url={mc_O1_url}
								render={(props) => {
									const { subscribe, status, message } = props || {};
									return (
										<OmniOneSub
											status={status}
											message={message}
											onValidated={(formData: any) => subscribe(formData)}
										/>
									);
								}}
							/>
						</Modal>
						<Modal
							title="Sign Up for Omni Arena News"
							visible={showOASubModalVisible}
							footer={null}
							onCancel={() => {
								hideOASubModal();
							}}
						>
							<p>Enter your email address below.</p>
							<MailchimpSubscribe
								url={mc_OA_url}
								render={(props) => {
									const { subscribe, status, message } = props || {};
									return (
										<OmniArenaSub
											status={status}
											message={message}
											onValidated={(formData: any) => subscribe(formData)}
										/>
									);
								}}
							/>
						</Modal>
						<Modal
							title="Sign Up for Omni Arena Esports News"
							visible={showOESubModalVisible}
							footer={null}
							onCancel={() => {
								hideOESubModal();
							}}
						>
							<p>Enter your email address below.</p>
							<MailchimpSubscribe
								url={mc_OE_url}
								render={(props) => {
									const { subscribe, status, message } = props || {};
									return (
										<OmniEsportsSub
											status={status}
											message={message}
											onValidated={(formData: any) => subscribe(formData)}
										/>
									);
								}}
							/>
						</Modal>

						<div className={styles.footerRow}>
							<div className={styles.footerColumn66}>
								<div className={styles.footerSignUpTerms}>
									By signing up you are agreeing to the Virtuix{' '}
									<a
										className={styles.footerLinkWhite}
										href="https://virtuix.com/terms-of-use"
									>
										Terms of Use{' '}
									</a>
									and Virtuix{' '}
									<a
										className={styles.footerLinkWhite}
										href="https://virtuix.com/privacy-policy"
									>
										Privacy Policy
									</a>
									. You may unsubscribe at any time.
								</div>
							</div>
							<div className={styles.footerColumn33}>
								<div className={styles.footerSignUpSocial}>
									<Link
										className={styles.footerSocialIconLink}
										to="//www.facebook.com/VirtuixOmni"
										target="_blank"
										aria-label="Home"
									>
										<img
											className={styles.footerSocialIconImg}
											src={facebookIcon}
											alt=""
										/>
									</Link>
									<Link
										className={styles.footerSocialIconLink}
										to="//www.instagram.com/virtuixomni/"
										target="_blank"
										aria-label="Instagram"
									>
										<img
											className={styles.footerSocialIconImg}
											src={instagramIcon}
											alt=""
										/>
									</Link>
									<Link
										className={styles.footerSocialIconLink}
										to={'//www.youtube.com/user/VirtuixOmni?view_as=subscriber'}
										target="_blank"
										aria-label="Youtube"
									>
										<img
											className={styles.footerSocialIconImg}
											src={youtubeIcon}
											alt=""
										/>
									</Link>
									<Link
										className={styles.footerSocialIconLink}
										to="//twitter.com/virtuixomni"
										target="_blank"
										aria-label="Twitter"
									>
										<img
											className={styles.footerSocialIconImg}
											src={twitterIcon}
											alt=""
										/>
									</Link>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}
